// AgeVerifyBadge — liten CTA i profil-header for egen bruker som ikke er
// alders-verifisert. Ordvalget er bevisst "alder", ikke "identitet" — bryter
// ikke med anonymitets-prinsippet på plattformen.
// Vises kun hvis: isSelf=true OG bruker mangler både bankid_verified og
// verification_level >= 1.
import React, { useEffect, useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function AgeVerifyBadge({ isSelf, className = "" }) {
  const [status, setStatus] = useState(null);
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    if (!isSelf) return;
    let alive = true;
    (async () => {
      try {
        const r = await api.get("/me/bankid/status");
        if (alive) setStatus(r.data);
      } catch {
        if (alive) setStatus(null);
      }
    })();
    return () => { alive = false; };
  }, [isSelf]);

  if (!isSelf || !status) return null;
  if (status.glimt_eligible) return null;   // Allerede verifisert (BankID eller kjøp)

  const start = async () => {
    setStarting(true);
    try {
      const r = await api.post("/me/bankid/start", { next_url: window.location.pathname });
      if (r.data.already_verified) {
        setStatus((s) => ({ ...(s || {}), bankid_verified: true, glimt_eligible: true }));
      } else if (r.data.redirect_url) {
        window.location.href = r.data.redirect_url;
      }
    } catch (e) {
      toast.error(formatApiError(e));
      setStarting(false);
    }
  };

  return (
    <button
      onClick={start}
      disabled={starting}
      className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 border border-[var(--magenta)]/60 text-[var(--magenta)] hover:bg-[var(--magenta)]/10 font-manrope not-italic uppercase tracking-wider transition-colors ${className}`}
      data-testid="profile-age-verify-badge"
      title="Verifiser at du er over 18 — via BankID (Strex Id). Åpner opp Glimt og andre 18+-funksjoner."
    >
      {starting ? <Loader2 className="h-3 w-3 animate-spin" /> : <ShieldCheck className="h-3 w-3" />}
      Verifiser alder
    </button>
  );
}
